/**
 *  @name: private.jsx
 *  @version: 1.0.0
 *  @author: Trejocode - Sergio
 *  @description: Página privada
 */

import React, { useState, useEffect } from "react";
import Layout from "./layout";
import Sidebar from "../components/header/sidebar";
import Calendar from "../components/calendar/calendarEvents";


function PurchasesCalendar(props) {
  const [user, setUser] = useState({
    idUsuario: 0,
    idPerfil: 0,
    nombre: "",
    idUbicacion: 0,
  });

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    const user = await props.context.loadUser();

    if (user) {
      setUser(user);
    }
  };

  return (
    <Layout
      title="Calendario de Eventos"
      description="Página privada de perfil"
      keywords="Reactjs, SEO Ready, Ejemplo"
    >
      <Sidebar />
      <Calendar id_modulo={3} user={user} />
    </Layout>
  );
}

export default PurchasesCalendar;
